// Pre-built therapy phrase library by discipline
// OT = Occupational Therapy, ST = Speech Therapy, PT = Physical Therapy

export const PHRASE_LIBRARY = {
  OT: {
    "Greeting & Setup": [
      "Hello, my name is {name}. I'm your occupational therapist.",
      "How are you feeling today?",
      "Are you in any pain right now? On a scale of 0 to 10.",
      "We will work together for about 45 minutes.",
      "Please tell me if you need a break.",
    ],
    "Activities of Daily Living": [
      "Can you show me how you brush your teeth?",
      "Let's practice getting dressed.",
      "Try buttoning this shirt with your weaker hand.",
      "Reach for the cup on the table, please.",
      "Can you bring the spoon to your mouth?",
    ],
    "Fine Motor": [
      "Pinch this clothespin and place it on the edge.",
      "Pick up the small beads one by one.",
      "Squeeze this putty as hard as you can.",
      "Open and close your hand ten times.",
      "Touch each finger to your thumb.",
    ],
    "Cognitive": [
      "What day of the week is it today?",
      "Repeat these three words back to me.",
      "Can you tell me where we are?",
      "Please follow these instructions in order.",
    ],
    "Encouragement": [
      "Good job. Keep going.",
      "You are doing great.",
      "Take your time. There is no rush.",
      "We can stop and rest if you need.",
    ],
  },
  ST: {
    "Greeting & Setup": [
      "Hello, my name is {name}. I'm your speech-language pathologist.",
      "Today we will work on speech and swallowing.",
      "If something is hard to understand, please raise your hand.",
      "Are you comfortable in this chair?",
    ],
    "Articulation": [
      "Repeat after me: 'pa pa pa'.",
      "Say the word 'apple' slowly.",
      "Open your mouth wide and say 'ahh'.",
      "Stick your tongue out and move it side to side.",
      "Round your lips like you are blowing a kiss.",
    ],
    "Swallowing / Dysphagia": [
      "Take a small sip of water.",
      "Swallow hard, then say 'ahh'.",
      "Tuck your chin to your chest before swallowing.",
      "Do not eat or drink until I say it is safe.",
      "Cough strongly for me, please.",
    ],
    "Language Comprehension": [
      "Point to the picture of the dog.",
      "Show me the spoon.",
      "Answer yes or no: Is the sky blue?",
      "Repeat this sentence after me.",
      "Tell me what you did this morning.",
    ],
    "Voice": [
      "Say 'ahh' in a high voice.",
      "Now say it in a low voice.",
      "Take a deep breath and hold it for five seconds.",
      "Try to speak more loudly.",
    ],
  },
  PT: {
    "Greeting & Setup": [
      "Hello, my name is {name}. I'm your physical therapist.",
      "Tell me where it hurts on a scale of 0 to 10.",
      "We will move slowly. Stop me if it hurts too much.",
      "Can you stand up by yourself or do you need help?",
    ],
    "Range of Motion": [
      "Lift your arm up over your head.",
      "Bend your knee toward your chest.",
      "Turn your head to the left, then to the right.",
      "Point your toes up, then down.",
      "Make a fist and then open your hand.",
    ],
    "Strength": [
      "Squeeze my hand as hard as you can.",
      "Push against my hand.",
      "Hold this position for ten seconds.",
      "Lift your leg without bending the knee.",
      "Try to stand up without using your arms.",
    ],
    "Gait & Balance": [
      "Walk to the door, then turn around and come back.",
      "Stand on one foot, please.",
      "Take small steps and look forward.",
      "Use the walker for support.",
      "Step up onto the curb with your stronger leg first.",
    ],
    "Pain & Safety": [
      "Tell me if you feel dizzy.",
      "Stop immediately if you feel sharp pain.",
      "Hold the rail with your right hand.",
      "Sit down slowly.",
      "Do you need to rest?",
    ],
  },
  COTA: {
    "Caregiver Education": [
      "I'll show your family how to help you with this exercise at home.",
      "Please watch how I position your hand — you can help them do the same.",
      "If you feel tired, ask your family to help you sit down.",
      "Here is a handout in your language with home exercises.",
      "Practice this five times a day, three times between visits.",
      "Tell your family member if you feel any pain.",
    ],
    "Adaptive Equipment": [
      "This is a reacher. Use it to pick up things from the floor.",
      "The button hook helps you fasten your shirt with one hand.",
      "Wear the sock aid like this to put on your socks.",
      "This long-handled sponge helps you wash your back and legs.",
      "Use the bath bench so you can sit while you shower.",
    ],
    "Energy Conservation": [
      "Sit down to brush your teeth or shave.",
      "Take short breaks while you are getting dressed.",
      "Plan harder tasks for the morning when you have more energy.",
      "Slide objects on the counter instead of lifting them.",
    ],
    "Reinforcing Goals": [
      "Today we're going to keep working on the goals your OT set.",
      "Last time you did very well — let's try a little more today.",
      "I'll write down how you did so your OT can see your progress.",
    ],
  },
  PTA: {
    "Safe Transfers": [
      "Move to the edge of the bed, feet flat on the floor.",
      "Push up from the bed with both hands.",
      "Hold the walker before you stand up.",
      "Pivot on your strong leg, then sit down slowly.",
      "Lock the wheelchair brakes before you stand.",
      "Don't pull on the walker — push down with your hands.",
    ],
    "Home Safety": [
      "Wear non-slip socks or shoes.",
      "Remove loose rugs from the floor.",
      "Turn the lights on before you walk at night.",
      "Keep one hand free to hold the rail on the stairs.",
      "Don't carry anything that blocks your view of the floor.",
    ],
    "Fall Recovery": [
      "If you fall, do not get up right away. Roll onto your side first.",
      "Crawl to a sturdy chair before standing.",
      "Press the emergency button if you can't get up.",
      "Tell me right away if you have fallen at home.",
    ],
    "Reinforcing Goals": [
      "Today we're going to keep working on the plan your PT set.",
      "Last time you walked 50 feet — let's aim for 60 today.",
      "I'll write down how you did so your PT can see your progress.",
    ],
  },
};

export const DISCIPLINE_LABEL = {
  OT: "Occupational Therapy",
  ST: "Speech Therapy",
  PT: "Physical Therapy",
  COTA: "Occupational Therapy Assistant",
  PTA: "Physical Therapist Assistant",
};
